import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Outlet, Navigate, useLocation } from "react-router-dom";

const ProtectedRoutes = () => {
  const location = useLocation();
  const user = useSelector((state) => state.user);

  useEffect(() => {
    if (!user.token) {
      const pathName = location.pathname;
      localStorage.setItem("redirectURL", pathName);
    }
  }, [user.token, location.pathname]);

  return user.token ? <Outlet /> : <Navigate to="/" />;
};

export default ProtectedRoutes;
